<template>
    <NavbarComp />
    <body>
        <div id="main">
            <div id="headerSection">
                <div id="leftHeader">
                    <div id="h1">
                        <h1>Hallo, teman-teman!!</h1>
                        <img src="../assets/hand.png">
                    </div>
                    <h2>Apakah kamu punya pertanyaan?</h2>
                </div>
                <div id="rightHeader">
                    <img src="../assets/headerImg.png">
                </div>
            </div>
            <div id="firstSection">
                <h3>Berikut beberapa pernyataan yang mungkin kamu ingin tanyakan</h3>
                <div class="dropdown">
                    <div id="isi">
                        <p>Bagaimana cara mendaftar akun di Intelligo.ID ?</p>
                        <img src="../assets/down.png">
                    </div>
                    <div class="dropdown-content">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Morbi vulputate adipiscing nullam donec a libero sem morbi ipsum. 
                            Quis sed habitant id in in viverra diam nulla integer. 
                            Tincidunt elit arcu mi justo. Vestibulum, orci quis arcu semper. 
                            Laoreet turpis dignissim viverra pellentesque senectus a. 
                        </p>
                    </div>
                </div>
                <div class="dropdown">
                    <div id="isi">
                        <p>Bagaimana cara log in akun Intelligo.ID ?</p>
                        <img src="../assets/down.png">
                    </div>
                    <div class="dropdown-content">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Morbi vulputate adipiscing nullam donec a libero sem morbi ipsum. 
                            Quis sed habitant id in in viverra diam nulla integer. 
                            Tincidunt elit arcu mi justo. Vestibulum, orci quis arcu semper. 
                            Laoreet turpis dignissim viverra pellentesque senectus a. 
                        </p>
                    </div>
                </div>
                <div class="dropdown">
                    <div id="isi">
                        <p>Apakah informasi pribadi saya di akun Intelligo.ID dirahasiakan?</p>
                        <img src="../assets/down.png">
                    </div>
                    <div class="dropdown-content">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Morbi vulputate adipiscing nullam donec a libero sem morbi ipsum. 
                            Quis sed habitant id in in viverra diam nulla integer. 
                            Tincidunt elit arcu mi justo. Vestibulum, orci quis arcu semper. 
                            Laoreet turpis dignissim viverra pellentesque senectus a. 
                        </p>
                    </div>
                </div>
                <div class="dropdown">
                    <div id="isi">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        <img src="../assets/down.png">
                    </div>
                    <div class="dropdown-content">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Morbi vulputate adipiscing nullam donec a libero sem morbi ipsum. 
                            Quis sed habitant id in in viverra diam nulla integer. 
                            Tincidunt elit arcu mi justo. Vestibulum, orci quis arcu semper. 
                            Laoreet turpis dignissim viverra pellentesque senectus a. 
                        </p>
                    </div>
                </div>
                <div class="dropdown">
                    <div id="isi">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        <img src="../assets/down.png">
                    </div>
                    <div class="dropdown-content">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Morbi vulputate adipiscing nullam donec a libero sem morbi ipsum. 
                            Quis sed habitant id in in viverra diam nulla integer. 
                            Tincidunt elit arcu mi justo. Vestibulum, orci quis arcu semper. 
                            Laoreet turpis dignissim viverra pellentesque senectus a. 
                        </p>
                    </div>
                </div>
                <div class="dropdown">
                    <div id="isi">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        <img src="../assets/down.png">
                    </div>
                    <div class="dropdown-content">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Morbi vulputate adipiscing nullam donec a libero sem morbi ipsum. 
                            Quis sed habitant id in in viverra diam nulla integer. 
                            Tincidunt elit arcu mi justo. Vestibulum, orci quis arcu semper. 
                            Laoreet turpis dignissim viverra pellentesque senectus a. 
                        </p>
                    </div>
                </div>
                <div class="dropdown">
                    <div id="isi">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        <img src="../assets/down.png">
                    </div>
                    <div class="dropdown-content">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Morbi vulputate adipiscing nullam donec a libero sem morbi ipsum. 
                            Quis sed habitant id in in viverra diam nulla integer. 
                            Tincidunt elit arcu mi justo. Vestibulum, orci quis arcu semper. 
                            Laoreet turpis dignissim viverra pellentesque senectus a. 
                        </p>
                    </div>
                </div>
                <div class="dropdown">
                    <div id="isi">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        <img src="../assets/down.png">
                    </div>
                    <div class="dropdown-content">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Morbi vulputate adipiscing nullam donec a libero sem morbi ipsum. 
                            Quis sed habitant id in in viverra diam nulla integer. 
                            Tincidunt elit arcu mi justo. Vestibulum, orci quis arcu semper. 
                            Laoreet turpis dignissim viverra pellentesque senectus a. 
                        </p>
                    </div>
                </div>
                <div class="dropdown">
                    <div id="isi">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        <img src="../assets/down.png">
                    </div>
                    <div class="dropdown-content">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Morbi vulputate adipiscing nullam donec a libero sem morbi ipsum. 
                            Quis sed habitant id in in viverra diam nulla integer. 
                            Tincidunt elit arcu mi justo. Vestibulum, orci quis arcu semper. 
                            Laoreet turpis dignissim viverra pellentesque senectus a. 
                        </p>
                    </div>
                </div>
                <div class="dropdown">
                    <div id="isi">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        <img src="../assets/down.png">
                    </div>
                    <div class="dropdown-content">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Morbi vulputate adipiscing nullam donec a libero sem morbi ipsum. 
                            Quis sed habitant id in in viverra diam nulla integer. 
                            Tincidunt elit arcu mi justo. Vestibulum, orci quis arcu semper. 
                            Laoreet turpis dignissim viverra pellentesque senectus a. 
                        </p>
                    </div>
                </div>
            </div>
            <div id="secondSection">
                <p>Tidak dapat menemukan yang kamu cari? Hubungi kami</p>
                <button id="chat" value="chat">Chat</button>
            </div>
        </div>
    </body>
    <FooterComp />
</template>

<script>
import NavbarComp from "./NavbarComp.vue";
import FooterComp from "./FooterComp.vue";

export default {
    name: 'FaqComp',
    components: {
        NavbarComp,
        FooterComp,
    },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
#main {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    font-family: "Poppins", sans-serif;
}
#headerSection {
    margin-bottom: 40px;
    background-color: #F5F5F5;
    width: 100%;
}
#headerSection #leftHeader {
    margin-top: 138px;
    margin-bottom: 138px;
    margin-left: 100px;
    width: 500px;
}
#headerSection #leftHeader #h1 {
    display: flex;
    flex-direction: row;
}
#headerSection #leftHeader h1 {
    font-size: 36px;
    font-weight: 600;
    color: #FF5400;
}
#headerSection #leftHeader img {
    height: 32px;
    width: 32px;
    object-fit: cover;
    margin-top: 5px;
    margin-left: 20px;
}
#headerSection #leftHeader h2 {
    text-align: left;
    margin-top: 30px;
    font-size: 28px;
    font-weight: 400;
    color: #023047;
}
#headerSection #rightHeader img{
    margin-top: 30px;
    margin-left: 300%;
}
#firstSection {
    display: flex;
    flex-direction: column;
    margin-left: 100px;
}
#firstSection h3 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 25px;
}
#firstSection #isi {
    display: flex;
    flex-direction: row;
    font-size: 20px;
    border-radius: 8px;
    background-color: #F5F5F5;
    padding: 10px 15px;
    margin-left: 120px;
    margin-bottom: 15px;
    width: 85%;
    cursor: pointer;
    color: #02283B;
}
#firstSection img {
    position: absolute;
    width: 20px;
    height: 12px;
    object-fit: cover;
    margin-top: 20px;
    margin-left: 75%;
}
/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #ddd;
  margin-left: 120px;
  max-width: 85%;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}
/* Links inside the dropdown */
.dropdown-content p {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
    display: block;
}
.dropdown:hover {
    margin-bottom: 150px;
}
#secondSection {
    margin-top: 120px;
    text-align: center;
    font-size: 26px;
    font-weight: 400;
}
#secondSection button {
    margin-top: 20px;
    margin-bottom: 120px;
    font-size: 26px;
    background-color: #FF5400;
    border-radius: 20px;
    padding: 20px 100px;
    color: white;
    cursor: pointer;
}

@media only screen and (max-width: 1100px) {
    #headerSection #rightHeader img{
        margin-left: 250%;
    }
}

@media only screen and (max-width: 950px) {
    #headerSection #rightHeader img{
        margin-left: 200%;
    }
}

@media only screen and (max-width: 750px) {
    #headerSection #leftHeader h1 {
        font-size: 28px;
    }
    #headerSection #leftHeader img {
        height: 24px;
        width: 24px;
        object-fit: cover;
        margin-left: 10px;
    }
    #headerSection #leftHeader h2 {
        font-size: 20px;
    }
    #headerSection #rightHeader img{
        margin-left: 150%;
    }
    #headerSection #leftHeader , #firstSection {
        margin-left: 70px;
    }
    #firstSection #isi , .dropdown-content {
        margin-left: 40px;
    }
}

@media only screen and (max-width: 500px) {
    #headerSection #leftHeader h1 {
        font-size: 20px;
    }
    #headerSection #leftHeader img {
        height: 16px;
        width: 16px;
        object-fit: cover;
        margin-left: 6px;
    }
    #headerSection #leftHeader h2 {
        margin-top: 15px;
        font-size: 12px;
    }
    #headerSection #rightHeader img{
        margin-left: 80%;
    }
    #headerSection #leftHeader , #firstSection {
        margin-left: 30px;
    }
    #firstSection #isi , .dropdown-content {
        margin-left: 40px;
    }
}
</style>